<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.titolo != null ? 'Nuova Push Notification - ' + this.$route.params.titolo : 'Nuova Push Notification')">

                    <b-container fluid class="mx-auto text-left" v-if="showdettaglio || this.$route.params.id_scheda == null">
                         <b-row class="my-1">
                                    <b-col sm="3"><label for="title">Titolo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="push.title" id="title" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="msg">Messaggio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea v-model="push.msg" id="msg" type="text" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="link">Link:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="push.link" id="link" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="redirectTo">Redirect to:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="push.redirectTo" id="redirectTo" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"></b-col>
                                    <b-col sm="9">
                                        <b-alert :show="true" variant="info">Nel campo "redirect to" può essere messo il Json che indica all'App quale schermata aprire, esempio per Evento: {"id": &lt;ID&gt;, "tipo": "E"}</b-alert>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="os">Filtra per tipo dispositivo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="push.os" :options="options_os" id="os">

                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="visibilità">Filtra per profilo soci:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="push.visibilita" :options="options_vispush" id="visibilità">

                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="listasoci">Filtra per N° Socio (separati da virgola):</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="listasoci" v-model="push.listasoci" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-3">
                                    <b-col sm="4" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="invia()" :disabled="inviaDisabled">
                                            Invia
                                            <b-spinner v-show="inviaDisabled" small type="grow"></b-spinner>
                                        </b-button>
                                    </b-col>
                                    <b-col sm="5">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="selSocio()">
                                            Seleziona socio
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="showsuccess" variant="success">
                        {{ success }}
                    </b-alert>

                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <!-- Modal Component -->
    <b-modal size="lg" v-model="sociModal.show" title="Seleziona il socio">
        <!-- <p class="my-2">Seleziona il socio</p> -->

        <div class="text-left">
            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="sociModal.filter" placeholder="Cerca..." />
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive small id="main-table" striped hover show-empty :items="sociModal.items" :fields="sociModal.fields" :current-page="sociModal.currentPage" :per-page="sociModal.perPage" :filter="sociModal.filter" :sort-by.sync="sociModal.sortBy" :sort-desc.sync="sociModal.sortDesc"
                @filtered="onFiltered">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="cognome" scope="row">{{row.value}}</template>
                <template slot="nome" scope="row">{{row.value}}</template>
                <!-- <template slot="matricola" scope="row">{{row.value}}</template> -->
                <template slot="account" scope="row">{{row.value}}</template>
                <template slot="seleziona" scope="row">
                <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-btn size="sm" variant="danger" @click.stop="seleziona(row.item,row.index,$event.target)">Seleziona</b-btn>
            </template>
            </b-table>


            <div class="row my-1">
                <div class="col-md-7 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="sociModal.perPage" v-model="sociModal.currentPage" />
                </div>
                <div class="col-md-5 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="sociModal.pageOptions" v-model="sociModal.perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>


        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="secondary" @click="sociModal.show=false" style="margin: 2px;">
                Chiudi
            </b-btn>
        </div>
    </b-modal>

</div>
</template>

<script>

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu
} from '../util.js'

import {
    Socio,
    Visibilità
} from '../classes.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {
            namespace: NAMESPACE,
            id_scheda: this.$route.params.id_scheda,
            tipo: this.$route.params.tipo,
            push: {
                title: this.$route.params.titolo || '',
                msg: '',
                link: '',
                redirectTo: '',
                listasoci: '',
                visibilita: 'T',
                os: 'Tutti'
            },
            options_os: ['Tutti', 'Android', 'iOS'],
            options_vispush: {
                'T': 'Soci + Familiari',
                'F': 'Solo familiari',
                'S': 'Solo soci'
            },
            inviaDisabled: false,
            error: '',
            success: '',
            showerror: false,
            showsuccess: false,
            showdettaglio: false,
            dismissSecs: 5,
            dismissCountDown: 0,
            modifica: true,
            sociModal: {
                show: false,
                items: [],
                fields: {
                    id: {
                        label: '#',
                        sortable: true
                    },
                    cognome: {
                        label: 'Cognome',
                        sortable: true
                    },
                    nome: {
                        label: 'Nome',
                        sortable: true
                    },
                    account: {
                        label: 'N° Socio',
                        sortable: true
                    },
                    seleziona: {
                        label: ' ',
                        'class': 'text-right'
                    }
                },
                currentPage: 1,
                perPage: 5,
                pageOptions: [{
                    text: 5,
                    value: 5
                }, {
                    text: 10,
                    value: 10
                }, {
                    text: 15,
                    value: 15
                }],
                sortBy: null,
                sortDesc: false,
                filter: null,
                totalRowsFilter: null,
            },
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.sociModal.totalRowsFilter || this.sociModal.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.sociModal.totalRowsFilter = newValue;
            }
        }
    },
    methods: {
        seleziona(item, index, button) {
            //this.partecipa.id_socio = item.id;
            //this.partecipa.nomesocio = item.nome;
            //this.partecipa.cognomesocio = item.cognome;
            //this.partecipa.accountsocio = item.email;
            //this.sociModal.show = false;
            if (this.push.listasoci.trim() == '' || this.push.listasoci.trim().endsWith(',')) {
                this.push.listasoci += item.account;
            } else {
                this.push.listasoci += ',' + item.account;
            }
            this.sociModal.show = false;
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.sociModal.currentPage = 1;
        },
        selSocio() {

                var token = localStorage.getItem('token');
                this.axios.get(NAMESPACE + 'rest/soci', {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                this.sociModal.items = response.data.message;
                                this.sociModal.items.forEach(function(element, index) {
                                    delete element.uteins; //per motivi di ricerca
                                });
                                this.sociModal.show = true;

                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            this.sociModal.showerror = true;
                            this.sociModal.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.sociModal.showerror = true;
                        this.sociModal.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });




            },
            invia() {

                if (this.push.title == "") {
                    alert("Campo titolo vuoto!");
                    return;
                }

                if (this.push.msg == "") {
                    alert("Campo messaggio vuoto!");
                    return;
                }

                this.inviaDisabled = true;
                this.showerror = false;
                this.showsuccess = false;
                this.error = '';
                this.success = '';

                var json = JSON.stringify(this.push);

                var appdettaglio = this;

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/sendpush', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    appdettaglio.showsuccess = true;
                                    appdettaglio.success = res;
                                    appdettaglio.inviaDisabled = false;

                                } else {
                                    throw new Error("Errore invio push notification!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                            appdettaglio.inviaDisabled = false;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        appdettaglio.inviaDisabled = false;
                    });
            }


    },
    created: function () {

            if(!ctrlVismenu("U")){
                this.$router.replace('/accessdenied');
                return;
            }

            //creo la tendina visibilità
            var visibilità = new Visibilità();
            var options_vis = [];
            for (var i = 0; i < Object.keys(visibilità.getListaTipi()).length; i++) {
                options_vis.push({
                    value: Object.keys(visibilità.getListaTipi())[i],
                    text: visibilità.getTipoByFlag(Object.keys(visibilità.getListaTipi())[i])
                });
            }
            this.options_visibilità = options_vis;

            var appdettaglio = this;

            if(this.id_scheda != null){

                var token = localStorage.getItem('token');

                this.axios.get(NAMESPACE + 'rest/soci/prenotazioni/id_scheda/' + this.id_scheda + '/tipo/' + this.tipo, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var listasoci = "";
                            var res = response.data.message;
                            if(res.length > 0){
                                res.forEach(function(element, index) {
                                    listasoci = listasoci + element.account + ",";
                                });
                                //rimuovo l'ultima virgola
                                listasoci = listasoci.slice(0,-1);
                                appdettaglio.push.listasoci = listasoci;
                            }
                            else{
                                alert("Nessun socio collegato trovato!")
                            }

                            appdettaglio.showdettaglio = true;

                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

            }

    }

}

</script>
